/**
 * Phase 10D: Feature flags (client-side).
 * Can be overridden by REACT_APP_* env vars if needed.
 */

export const FEATURES = {
  renewalIntelligence: process.env.REACT_APP_RENEWAL_CHECK_ENABLED !== 'false',
  renewalCalendar: process.env.REACT_APP_CALENDAR_VIEW_ENABLED !== 'false',
  multiPolicyComparison: process.env.REACT_APP_MULTI_COMPARE_ENABLED !== 'false',
  shareRecommendations: process.env.REACT_APP_SHARE_ENABLED !== 'false',
  recommendationHistory: true,
  premiumHistoryChart: true,
  autoRenewalSettings: process.env.REACT_APP_AUTO_RENEWAL_ENABLED !== 'false',
  pwaInstallPrompt: process.env.REACT_APP_PWA_ENABLED !== 'false',
  autoRefreshDashboard: process.env.REACT_APP_AUTO_REFRESH_ENABLED !== 'false',
};

export const REFRESH_INTERVAL = parseInt(process.env.REACT_APP_REFRESH_INTERVAL || '60000', 10);
